export default {
      id: "Icon--mapAndroidMyLocation-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "sprite.svg#Icon--mapAndroidMyLocation",
      toString: function () {
        return this.url;
      }
    }